import { t } from '@avalara/bat-apps-shared/i18n';
import type React from 'react';
import styled from 'styled-components';

const IframeWrapper = styled.div<{
  hideIframe: boolean;
  adjustWidth: boolean;
}>`
  display: ${(props) => (props.hideIframe ? 'none' : 'block')};
  iframe {
    width: 100%;
    ${(props) => (props.adjustWidth ? 'max-width: 750px' : '')}
  }
`;
const SecurityBlanket = styled.div<{
  hideIframe: boolean;
  zeroHeight: boolean;
}>`
  position: absolute;
  background: var(--color-surface-muted);
  height: ${(p) => (p.zeroHeight === true ? '0' : '100%')};
  width: 100%;
  display: ${(p) => (p.hideIframe ? 'block' : 'none')};
`;
type Props = {
  hideIframe: boolean;
  isCybersource?: boolean;
  children?: React.ReactNode;
  adjustWidth?: boolean;
};

const IframePaymentContainer = ({ hideIframe, children, adjustWidth = false }: Props) => (
  <>
    {/* blanket needed to hide iframe in FullStory or something */}
    <SecurityBlanket hideIframe={hideIframe} zeroHeight={hideIframe} />
    <IframeWrapper hideIframe={hideIframe} adjustWidth={adjustWidth}>
      <iframe
        id='cybersource-page'
        name='cybersource-page'
        title={t('client.accessibility.credit-card-fields')}
        height='1150'
      />
      {children}
    </IframeWrapper>
  </>
);

export default IframePaymentContainer;
